import styled from "@emotion/styled";
import { teamNames } from "../Consts";
import { brackets, logos } from "../data";

const ScoresWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TeamDiv = styled.div`
  border: 0.1px solid grey;
  border-radius: 5px;
  padding: 10px;
  margin: 30px;
  width: 400px;
  text-align: center;
  h4 {
    width: 100%;
    text-align: center;
  }
`;

export function Brackets({ scores }) {
  // console.log('🧠🧠🧠', scores);
  return (
    <ScoresWrap>
      <h1>Brackets</h1>
      <div>
        {teamNames.map((t) => {
          return (
            <TeamDiv>
              <img alt="logo" style={{ height: "80px" }} src={logos[t]} />
              <div style={{ textTransform: "capitalize" }}>
                <h1>EAST</h1>
                <p>{brackets[t].east.rd1}</p>
                <p>{brackets[t].east.rd2}</p>
                <p>{brackets[t].east.rd3}</p>
                <h1>🏆️ {brackets[t].cup}</h1>
                <h1>🦸 {brackets[t].mvp}</h1>
                <p>{brackets[t].west.rd3}</p>
                <p>{brackets[t].west.rd2}</p>
                <p>{brackets[t].west.rd1}</p>
                <h1>WEST</h1>
              </div>
            </TeamDiv>
          );
        })}
      </div>
    </ScoresWrap>
  );
}
